import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Vehicles from "./pages/Vehicles";
import VehicleDetail from "./pages/VehicleDetail";
import CustomerDashboard from "./pages/CustomerDashboard";
import VendorDashboard from "./pages/VendorDashboard";
import AdminDashboard from "./pages/AdminDashboard";

// Stable references — keep at module scope so React doesn't see "new" objects on each render.
const TOASTER_OPTIONS = {
  style: { background: "#0A111A", border: "1px solid rgba(255,255,255,0.08)", color: "#F8FAFC" },
};
const ROLE_CUSTOMER = ["customer"];
const ROLE_VENDOR = ["vendor"];
const ROLE_ADMIN = ["admin"];

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" toastOptions={TOASTER_OPTIONS} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/vehicles" element={<Vehicles />} />
          <Route path="/vehicles/:id" element={<VehicleDetail />} />
          <Route path="/dashboard" element={<ProtectedRoute roles={ROLE_CUSTOMER}><CustomerDashboard /></ProtectedRoute>} />
          <Route path="/vendor" element={<ProtectedRoute roles={ROLE_VENDOR}><VendorDashboard /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute roles={ROLE_ADMIN}><AdminDashboard /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
